<template>
    <modal :title="title" :id="id" :actionButtons="false" size="full" :closeButton="true" @shown="shown() ">
        <template slot="modal-header">
            <span></span>
        </template>

        <div class="row">
            <div class="col-auto">
                <img
                    :src="billing.avatar.preview"
                    v-if="billing.avatar"
                    alt="..."
                    class="img-fluid mb-4"
                    style="max-width: 75px;"
                />
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <div class="row">
                    <div class="col-4">
                        <h6 class="card-title text-uppercase text-muted mb-2">To:</h6>
                        <p>{{ exam.user }} Dadajonov O. 33 yrs old Male</p>
                    </div>
                    <div class="col-4">
                        <h6 class="card-title text-uppercase text-muted mb-2">By:</h6>
                        <p>{{ exam.user }} Pulatova M. trichologist</p>
                    </div>
                    <div class="col-4">
                        <h6 class="card-title text-uppercase text-muted mb-2">Date</h6>
                        <p>{{ exam.user }} 19 April 2019</p>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <div class="row mt-5">
            <div class="col-12 col-md-12 mb-5" v-if="exam.complaints">
                <h6 class="card-title text-uppercase text-muted mb-2">Complaints</h6>
                <p>{{ exam.complaints }}</p>
            </div>
            <div class="col-12 col-md-12 mb-5" v-if="exam.examination">
                <h6 class="card-title text-uppercase text-muted mb-2">Examination</h6>
                <p>{{ exam.examination }}</p>
            </div>
            <div class="col-12 col-md-12 mb-5" v-if="exam.conclusion">
                <h6 class="card-title text-uppercase text-muted mb-2">Conclusion</h6>
                <p>{{ exam.conclusion }}</p>
            </div>

            <div class="col-12 col-md-6 mb-5" v-if="exam.diagnosis.length>0">
                <h6 class="card-title text-uppercase text-muted mb-2">Preliminary diagnosis</h6>
                <b-form-group label>
                    <ul class="navbar-nav mb-md-3">
                        <li class="nav-item" v-for="(item, index) in exam.diagnosis" :key="index">
                            <span class="nav-link">
                                <strong>{{item.code}}</strong>
                                {{item.label}}
                            </span>
                        </li>
                    </ul>
                </b-form-group>
            </div>
            <div class="col-12 col-md-12" v-if="exam.treatment">
                <h6 class="card-title text-uppercase text-muted mb-2">Treatment</h6>
                <p>{{ exam.treatment }}</p>
            </div>
        </div>
        <template slot="modal-footer">
            <div class="row d-none">
                <div class="col-12 col-lg-10 col-xl-8 p-5 text-muted border-top">Document generated by MyClient.uz</div>
            </div>
            <div class="card-footer never-print" style="display:block">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-white mr-2" @click="print()">
                            <i class="fe fe-printer"></i> Print
                        </button>
                        <button type="button" @click="close" class="btn btn-white">Close</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { icdMixins } from '@/components/ICD10/icd-mixins.js'
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';


export default {
    props: ['id', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,

    },
    data() {
        return {
            title: 'Exam',
            tab: 'general',
            billing: {},
            exam: {
                diagnosis: [],
                customerId: this.$route.params.id,
            }
        }
    },
    methods: {
        ...mapActions('my-company', { getMyCompany: 'get' }),
        shown() {
            this.exam = {
                diagnosis: [],
                customerId: this.$route.params.id,
            }
            Object.assign(this.exam, JSON.parse(JSON.stringify(this.data)));

            this.getMyCompany("mine").then(data => {
                this.billing = data.billing;
                this.billing.avatar = data.avatar;
            });
        },
        print() {
            window.print();
        },
        close() {
            this.$root.$emit('bv::hide::modal', this.id);
        },
    }
}
</script>
<style>
    @media print {
        .modal-header {
            display: none !important;
        }
    }
</style>
